import { atom } from 'jotai'
import { Offering } from '../../Api/Lirari/Types/offering'

export const offeringsAtom = atom<Offering[]>([])
